// // import React from "react";
// // import { FaTimesCircle } from "react-icons/fa";
// // import { Link } from "react-router-dom";

// // const PaymentFailure = () => {
// //   return (
// //     <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black bg-opacity-50 px-4">
// //       <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center animate-fade-in">
// //         {/* Icon */}
// //         <div className="flex justify-center mb-4">
// //           <FaTimesCircle className="text-red-500 md:text-7xl text-5xl" />
// //         </div>

// //         {/* Title & Message */}
// //         <h2 className="text-2xl font-bold text-gray-800">Payment Failed</h2>
// //         <p className="text-gray-600 mt-2">
// //           Sorry, we couldn’t complete your payment. Please try again later.
// //         </p>

// //         <hr className="my-6 border-gray-300" />

// //         {/* Failure Details */}
// //         <div className="text-left text-sm text-gray-700 space-y-2">
// //           <div className="flex justify-between">
// //             <span className="font-medium text-gray-600">Attempted Amount:</span>
// //             <span className="font-semibold text-black">Rs 99.99</span>
// //           </div>
// //           <div className="flex justify-between">
// //             <span className="font-medium text-gray-600">Payment Method:</span>
// //             <span className="text-black">Visa ending in 1234</span>
// //           </div>
// //           <div className="flex justify-between">
// //             <span className="font-medium text-gray-600">Date & Time:</span>
// //             <span className="text-black">April 18, 2024 at 3:45 PM</span>
// //           </div>
// //         </div>

// //         {/* Buttons */}
// //         <div className="mt-6 flex justify-center gap-4">
// //           <Link to="/payment">
// //             <button
// //               className="bg-red-600 text-white px-5 py-2 rounded-md hover:bg-red-700 transition"
// //               // onClick={() => window.location.reload("/payment")}
// //             >
// //               Try Again
// //             </button>
// //           </Link>
// //           <Link to="/">
// //             <button className="bg-red-600 text-white px-5 py-2 rounded-md hover:bg-red-700 transition">
// //               Cancel
// //             </button>
// //           </Link>
// //         </div>
// //       </div>

// //       {/* Animation */}
// //       <style>
// //         {`
// //           @keyframes fade-in {
// //             0% { opacity: 0; transform: scale(0.95); }
// //             100% { opacity: 1; transform: scale(1); }
// //           }
// //           .animate-fade-in {
// //             animation: fade-in 0.3s ease-out;
// //           }
// //         `}
// //       </style>
// //     </div>
// //   );
// // };

// // export default PaymentFailure;

// import React, { useEffect, useState } from "react";
// import { useSearchParams, Link } from "react-router-dom";
// import BASE_URL from "../../config/config";

// const PaymentFailure = () => {
//   const [q] = useSearchParams();
//   const txnId = q.get("txnid");
//   const [txn, setTxn] = useState(null);

//   useEffect(() => {
//     if (txnId) {
//       fetch(`${BASE_URL}/payments/txns/${txnId}`)
//         .then((r) => (r.ok ? r.json() : null))
//         .then(setTxn)
//         .catch(console.error);
//     }
//   }, [txnId]);

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-red-50 p-6">
//       <div className="bg-white shadow rounded-xl p-8 max-w-lg w-full text-center">
//         <h1 className="text-3xl font-bold text-red-600">Payment Failed ❌</h1>
//         <p className="mt-2 text-gray-600">
//           Your transaction could not be completed.
//         </p>
//         {txn && (
//           <div className="mt-6 text-left bg-gray-50 p-4 rounded">
//             <p>
//               <b>Txn ID:</b> {txn.txnId}
//             </p>
//             <p>
//               <b>Status:</b> {txn.status}
//             </p>
//             {txn.failureReason && (
//               <p>
//                 <b>Reason:</b> {txn.failureReason}
//               </p>
//             )}
//             <p>
//               <b>Amount:</b> ₹{txn.amount}
//             </p>
//             <p>
//               <b>Product:</b> {txn.productInfo}
//             </p>
//           </div>
//         )}
//         <Link
//           to="/pay"
//           className="inline-block mt-6 px-4 py-2 bg-sky-600 text-white rounded"
//         >
//           Try again
//         </Link>
//       </div>
//     </div>
//   );
// };

// export default PaymentFailure;

// import React, { useEffect, useState } from "react";
// import BASE_URL from "../../config/config";
// const FailurePage = () => {
//   const [message, setMessage] = useState("Processing your payment result...");

//   useEffect(() => {
//     const urlParams = new URLSearchParams(window.location.search);
//     const payuResponse = {};

//     urlParams.forEach((value, key) => {
//       payuResponse[key] = value;
//     });

//     // ✅ Send failure response to backend
//     fetch(`${BASE_URL}/payments/failure`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify(payuResponse),
//     })
//       .then((res) => {
//         if (!res.ok) throw new Error("Failed to save payment");
//         return res.text();
//       })
//       .then((data) => {
//         setMessage("❌ Payment Failed. Please try again.");
//       })
//       .catch((err) => {
//         console.error(err);
//         setMessage("⚠ Payment failed, and we could not record it.");
//       });
//   }, []);

//   return (
//     <div style={{ textAlign: "center", marginTop: "100px" }}>
//       <h2>{message}</h2>
//       <p>If money is deducted, it will be refunded automatically.</p>
//     </div>
//   );
// };

// export default FailurePage;

// FailurePage.jsx
// import { useEffect, useState } from "react";
// import { useSearchParams } from "react-router-dom";
// import BASE_URL from "../../config/config";

// export default function FailurePage() {
//   const [params] = useSearchParams();
//   const [tx, setTx] = useState(null);
//   const txnid = params.get("txnid");

//   useEffect(() => {
//     fetch(`${BASE_URL}/payments/txns/${txnid}`)
//       .then((res) => res.json())
//       .then(setTx);
//   }, [txnid]);

//   if (!tx) return <p>Loading...</p>;

//   return (
//     <div className="p-6">
//       <h1 className="text-red-600 text-2xl font-bold">Payment Failed ❌</h1>
//       <p>Transaction ID: {tx.txnid}</p>
//       <p>Amount: ₹{tx.amount}</p>
//       <p>Product: {tx.productInfo}</p>
//       <p>Status: {tx.status}</p>
//       <p>Payment Mode: {tx.mode}</p>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import BASE_URL from "../../config/config";
import { FaTimesCircle, FaHome } from "react-icons/fa";

export default function FailurePage() {
  const [params] = useSearchParams();
  const [tx, setTx] = useState(null);
  const txnid = params.get("txnid");
  const navigate = useNavigate();

  useEffect(() => {
    if (txnid) {
      fetch(`${BASE_URL}/payments/txns/${txnid}`)
        .then((res) => res.json())
        .then(setTx)
        .catch((err) => console.error("Error fetching transaction:", err));
    }
  }, [txnid]);

  if (!tx)
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <p className="text-gray-500 text-lg animate-pulse">
          Loading payment details...
        </p>
      </div>
    );

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-red-50 via-white to-red-100 px-4">
      <div className="max-w-md w-full bg-white rounded-3xl shadow-2xl border border-red-200 p-8 text-center relative overflow-hidden transition-all duration-300 hover:shadow-red-200">
        {/* Header Bar */}
        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-red-400 via-rose-500 to-red-600"></div>

        {/* Icon and Title */}
        <div className="flex flex-col items-center mb-5">
          <div className="bg-gradient-to-r from-red-500 to-rose-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg mb-4">
            <FaTimesCircle className="text-3xl" />
          </div>
          <h1 className="text-2xl font-extrabold text-red-600">
            Payment Failed
          </h1>
          <p className="text-gray-600 mt-1">
            Oops! Something went wrong with your transaction ❌
          </p>
        </div>

        {/* Transaction Details */}
        <div className="text-left text-gray-700 border-t pt-5 space-y-3">
          <div className="flex justify-between">
            <span className="font-semibold">Transaction ID:</span>
            <span>{tx.upiRefNo}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Amount:</span>
            <span className="text-red-600 font-bold">₹{tx.amount}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Product:</span>
            <span>{tx.product}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Status:</span>
            <span className="text-red-600 font-semibold uppercase">
              {tx.status}
            </span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Error:</span>
            <span>{tx.errorMessage}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Payment Mode:</span>
            <span>{tx.paymentMode || "N/A"}</span>
          </div>
          <div className="flex justify-between">
            <span className="font-semibold">Date:</span>
            <span>{new Date(tx.date).toLocaleString()}</span>
          </div>
        </div>

        {/* Buttons */}
        <div className="mt-8 flex flex-col gap-3">
          <button
            onClick={() => navigate("/")}
            className="flex items-center justify-center gap-2 w-full bg-white border-2 border-red-500 text-red-600 py-3 rounded-full font-semibold hover:bg-red-50 transition-all duration-300"
          >
            <FaHome />
            Back to Home
          </button>
        </div>

        {/* Footer */}

        <p className="text-xs text-gray-400 mt-4">
          Need help?{" "}
          <a
            href="mailto:support@ivrguru.com"
            className="text-blue-500 hover:underline"
          >
            Contact: support@ivrguru.com
          </a>
        </p>
      </div>
    </div>
  );
}
